import Navbar from "./Common/Navbar";
import { Container } from "../styled/Container.styled";
import { StyledAuthorHeader } from "../styled/AuthorHeader.styled";

function AuthorHeader({ author }) {
  return (
    <>
      <Navbar />
      <Container>
        <StyledAuthorHeader>
          <div className="author-img">
            <img
              src={author.image}
              loading="lazy"
              alt={author.name}
              className="global-image"
            />{" "}
          </div>
          <h1>{author.name}</h1>
          <span>{author.postCount} posts</span>
          <div className="socials">
            {author.location && (
              <span>
                <svg
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 0C6.908 0 2.766 4.143 2.766 9.234c0 1.529.456 3.028 1.108 4.388C5.872 17.785 11.79 24 12 24c.21 0 6.524-6.908 8.128-10.382.632-1.368 1.106-2.855 1.106-4.384C21.234 4.143 17.092 0 12 0zm0 4.425a4.663 4.663 0 014.661 4.661A4.663 4.663 0 0112 13.747a4.663 4.663 0 01-4.661-4.661A4.663 4.663 0 0112 4.425z"></path>
                </svg>
                {author.location}
              </span>
            )}
            {author.website && (
              <a href={author.website} aria-label="link Website">
                <svg
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 12C0 5.374 5.374 0 12 0c6.628 0 12 5.374 12 12 0 6.628-5.372 12-12 12-6.626 0-12-5.372-12-12zm5.593-.866a5.34 5.34 0 0 0-1.558 3.74c0 2.868 2.369 5.237 5.174 5.174a5.235 5.235 0 0 0 3.74-1.558l1.559-1.558-1.746-1.745-1.558 1.558a2.737 2.737 0 0 1-1.933.81c-1.496 0-2.743-1.246-2.743-2.743 0-.748.313-1.434.81-1.932l1.559-1.558-1.745-1.746-1.559 1.559v-.001zm7.62-1.962l-4.85 4.85 1.698 1.696 4.848-4.85-1.696-1.696zm4.843 4.212a5.34 5.34 0 0 0 1.558-3.741c0-2.868-2.368-5.236-5.173-5.174A5.232 5.232 0 0 0 10.7 6.03L9.142 7.585l1.746 1.746 1.558-1.56a2.738 2.738 0 0 1 1.932-.809c1.496 0 2.743 1.246 2.743 2.742a2.74 2.74 0 0 1-.81 1.933l-1.56 1.559 1.746 1.745 1.56-1.558z"></path>
                </svg>
                Website
              </a>
            )}

            {author.facebook && (
              <a href={author.facebook} aria-label="link Facebook">
                <svg
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z"></path>
                </svg>
                Facebook
              </a>
            )}

            {author.twitter && (
              <a href={author.twitter} aria-label="link Twitter">
                <svg
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"></path>
                </svg>
                Twitter
              </a>
            )}
          </div>
          <p>{author.bio}</p>
        </StyledAuthorHeader>
      </Container>
    </>
  );
}

export default AuthorHeader;
